import {
  IonIcon,
  IonImg,
  IonItem,
  IonList,
  IonMenu,
  IonMenuToggle,
} from "@ionic/react";

import { useHistory, useLocation } from "react-router-dom";
import {
  calendarOutline,
  calendar,
  fileTrayFullOutline,
  fileTrayFull,
  flaskOutline,
  flask,
  medkitOutline,
  medkit,
  logOutOutline,
  logOut,
  gridOutline,
  grid,
  logoWhatsapp,
  peopleCircleOutline,
  peopleCircle,
} from "ionicons/icons";
import "./Menu.css";
import { useEffect, useState } from "react";
import ModalPacienteForm from "../ModalFormPaciente/ModalFormPaciente";
import { Link, Typography } from "@mui/joy";
import { Column, Row } from "../../basicsComponents/MaterialGridComponents";
import { createOutline } from "ionicons/icons";

const appPages = [
  {
    title: "Inicio",
    url: "/portal/Inicio",
    iosIcon: gridOutline,
    mdIcon: grid,
  },
  {
    title: "Reservar Turno",
    url: "/portal/Reservar turno",
    iosIcon: peopleCircleOutline,
    mdIcon: peopleCircle,
  },
  {
    title: "Reservar Turno Estudios",
    url: "/portal/Reservar turno estudios",
    iosIcon: medkitOutline,
    mdIcon: medkit,
  },
  {
    title: "Mis Turnos",
    url: "/portal/Turnos",
    iosIcon: calendarOutline,
    mdIcon: calendar,
  },
  {
    title: "Mis Estudios",
    url: "/portal/Estudios",
    iosIcon: fileTrayFullOutline,
    mdIcon: fileTrayFull,
  },
];

const LABORATORIO_URL = "https://cloudlablace.com.ar/#/login";

const Menu = () => {
  const location = useLocation();
  const [usuario, setUsuario] = useState({});
  const [openModalPaciente, setOpenModalPaciente] = useState(false);

  const [, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir === true) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();

  useEffect(() => {
    try {
      setUsuario(JSON.parse(sessionStorage.getItem("ppUL")));
    } catch {
      history.push({ pathname: "/ErrorPage" });
    }
  }, [history]);

  const handleClickLaboratorio = () => {
    window.open(LABORATORIO_URL, "_blank", "noopener,noreferrer");
  };

  const abrirModalPaciente = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setOpenModalPaciente(true);
  };

  const renderMenuItem = (appPage, index, usarMenuToggle) => {
    const item = (
      <IonItem
        className={location.pathname === appPage.url ? "selected" : ""}
        routerLink={appPage.url}
        routerDirection="none"
        lines="none"
        detail={false}
      >
        <IonIcon
          aria-hidden="true"
          slot="start"
          ios={appPage.iosIcon}
          md={appPage.mdIcon}
        />
        <Typography
          sx={{
            color: location.pathname === appPage.url ? "##B50009" : "#000",
          }}
          level={location.pathname === appPage.url ? "title-md" : "title-sm"}
        >
          {appPage.title.toUpperCase()}
        </Typography>
      </IonItem>
    );

    if (!usarMenuToggle) {
      return <div key={index}>{item}</div>;
    }

    return (
      <IonMenuToggle key={index} autoHide={false}>
        {item}
      </IonMenuToggle>
    );
  };

  const renderMenuContent = (usarMenuToggle = true) => (
    <>
      <div className="menu-layout">
        <div className="menu-scroll-container">
          <Row container>
            <IonImg
              src="assets/icon/logo.jpg"
              style={{
                width: "60%",
                justifyContent: "center",
                padding: "10px",
              }}
            />
            <button
              type="button"
              className="menu-user-button"
              onPointerDown={abrirModalPaciente}
              onClick={abrirModalPaciente}
            >
              <Typography
                level="title-lg"
                className="encabezado"
                sx={{ color: "##B50009" }}
              >
                {usuario.apellido}, {usuario.nombre}
                <IonIcon
                  icon={createOutline}
                  style={{
                    marginLeft: "20px",
                    fontSize: "25px",
                    cursor: "pointer",
                    color: "primary",
                  }}
                  title="Ver datos de usuario"
                />
              </Typography>

              <Typography
                level="title-md"
                className="encabezado"
                sx={{ color: "##B50009" }}
              >
                {usuario.email}
              </Typography>
            </button>
            <IonList id="inbox-list" style={{ marginTop: "7.5px" }}>
              {appPages.map((appPage, index) =>
                renderMenuItem(appPage, index, usarMenuToggle),
              )}
              <IonItem
                button
                lines="none"
                detail={false}
                onClick={handleClickLaboratorio}
                className={
                  location.pathname === "/portal/Laboratorio" ? "selected" : ""
                }
              >
                <IonIcon
                  aria-hidden="true"
                  slot="start"
                  ios={flaskOutline}
                  md={flask}
                  style={{ color: "var(--ion-color-secondary-shade)" }}
                />
                <Typography
                  level="title-sm"
                  sx={{
                    color: "var(--ion-color-secondary-shade)",
                    fontWeight: "bold",
                  }}
                >
                  {`Laboratorio`.toUpperCase()}
                </Typography>
              </IonItem>
              <IonItem button lines="none" className="amarillo-sol">
                <IonIcon slot="start" icon={logoWhatsapp} />
                <Typography level={"title-sm"}>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://web.whatsapp.com/send?phone=+5493515079642&text=Hola!%20quiero%20hacer%20una%20consulta!"
                  >
                    {`Nuestro Whatsapp`.toUpperCase()}
                  </a>
                </Typography>
              </IonItem>
              <IonItem button lines="none" routerLink={"/"}>
                <IonIcon
                  aria-hidden="true"
                  color="solid"
                  slot="start"
                  ios={logOutOutline}
                  md={logOut}
                />
                <Typography variant="title-sm" color="danger">
                  {`Cerrar Sesion`.toUpperCase()}
                </Typography>
              </IonItem>
            </IonList>
          </Row>
        </div>

        <Row
          container
          justifyContent="center"
          alignItems="center"
          className="menu-footer"
        >
          <Column container justifyContent="space-between" alignItems="center">
            <Link
              href="https://www.gacitua.com.ar/"
              rel="Proveedor del servicio noreferrer"
              target="_blank"
            >
              <Typography level="title-lg">
                <Typography color="neutral"> {"Powered by "}</Typography>
                <img
                  src={"assets/logoGacitua.png"}
                  alt="logo gacitua y asociados"
                  width={17}
                  height={17}
                />
                <Typography> {" Gacitua & Asociados"}</Typography>
              </Typography>
            </Link>
          </Column>
        </Row>
      </div>
    </>
  );

  return (
    <>
      <aside className="desktop-side-menu">{renderMenuContent(false)}</aside>

      <IonMenu contentId="main" type="overlay" className="mobile-side-menu">
        {renderMenuContent(true)}
      </IonMenu>

      <ModalPacienteForm
        openModal={openModalPaciente}
        setOpenModal={setOpenModalPaciente}
        mostrarNotificacion={mostrarNotificacion}
        paciente={usuario}
        setPaciente={setUsuario}
      />
    </>
  );
};

export default Menu;
